import { DocumentWorkflowType } from 'src/app/shared/models/document-workflow';

export class DocumentWorkflowTask {
  Id: number;
  Type: DocumentWorkflowType;
  DocumentId: number;
  SendDate: string;
  LastSendAttemptDate?: string;
  LastSendError?: string;

  ContextBuildingCode: string;
  ContextType: string;
  ContextCode: string;
}
